import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { TableFilterMenu } from '@interxfi/design-system/components/table/filter/table-filter-menu';
import type { IxcRaglV1TransactionQueryServiceTransactionListFilterableFields } from '@interxfi/types/generated/api';
import { PageTabRail } from '../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../components/router/router-tabbed-navigation';
import { RaglTransactionsTable } from '../../../../../../../../../features/clearing-ledger/transaction/ragl-transactions-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsCore,
      label: 'Transactions',
      order: 5,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsCore>,
  head: () => getPageHead('Transactions'),
  component: ClearingTransactionList,
});

function TableHeader({ filterProps }: CustomTableHeaderProps<IxcRaglV1TransactionQueryServiceTransactionListFilterableFields>) {
  return (
    <PageTabRail
      actions={
        filterProps ? (
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <TableFilterMenu<IxcRaglV1TransactionQueryServiceTransactionListFilterableFields> {...filterProps} />
          </HorizontalStack>
        ) : null
      }
      group={TabbedNavigationGroup.ClearingOperationsCore}
    />
  );
}

function ClearingTransactionList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglTransactionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
